<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>Native Wind</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By A.M. Burns</p>
<p class="P_Normal"> </p>
<p class="P_Normal">After his family is killed by thieves, sole survivor Trey McAlister is taken in by a nearby Comanche clan. Trey has a gift for magic and the clan’s shaman, Singing Crow, makes him an apprentice. While learning to control his powers, Trey bonds with a young warrior and shape-shifter, Gray Talon. When they are sent out on a quest to find the missing daughter of a dragon, they encounter the same bandits who murdered Trey’s family, as well as a man made of copper who drives Trey to dig deeper into the magics that created him.</p>
<p class="P_Normal">It doesn’t take them long to discover a rancher near Cheyenne, Wyoming is plotting to build a workforce of copper men—and has captured the dragon’s daughter they’ve been searching for. Trey and Gray Talon must draw on all their knowledge and skills to complete their quest—one that grows more complicated, and more dangerous, with each passing day.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?543af75c